import React from 'react'
import useTranslation from '../../../shared/TranslationProvider'
import candidateChatManager from '../../candidate/CandidateChatManager'
import { buildCoachListLabels } from '../shared/buildCoachListLabels'
import CoachListSections from '../shared/CoachListSections'
import {
  getAvailableCoachesHeading,
  getCoachJobTitle,
} from '../shared/getCoachJobTitle'
import { useExpandedCoaches } from '../shared/useExpandedCoaches'
import { useCoachListConnection } from './useCoachListConnection'

/**
 * Candidate coach list inside the floating chat modal (CoachChatButton).
 */
const CoachChatList = (props) => {
  const {
    open,
    inHours,
    userCareerDevelopment = false,
    mediaAvailable = true,
    modalCopy,
    deloitteUser = false,
  } = props
  const { t } = useTranslation()
  const { toggleCoachExpanded, isCoachExpanded } = useExpandedCoaches()
  const labels = buildCoachListLabels(t)
  const { isConnected, coaches, availableCoaches, busyCoaches } =
    useCoachListConnection(props)

  const handleCoachAction = (coach, selectedChatMode) => {
    const ringStartTime = new Date()

    candidateChatManager.logEvent(
      'call_initiated',
      {
        time: ringStartTime,
        easyrtcid: coach.easyrtcid,
      },
      window.conversationId,
    )

    const coachIdInput = document.getElementById('coach_id')
    const conversationStarterInput = document.getElementById(
      'conversation_starter',
    )
    const chatModeInput = document.getElementById('chat_mode')
    const coachChatForm = document.getElementById('coach_chat_form')

    if (coachIdInput) coachIdInput.value = coach.easyrtcid
    if (conversationStarterInput) {
      conversationStarterInput.value = window.conversationStarter || ''
    }
    if (chatModeInput) chatModeInput.value = selectedChatMode

    // Soft handoff: keep Starting Chat visible across video-chat-frame navigation
    candidateChatManager.beginChatHandoff(window.conversationId)

    const submitCoachChatForm = () => {
      if (coachChatForm) {
        if (window.$ && window.$('#coach_chat_form').length > 0) {
          window.$('#coach_chat_form').trigger('submit')
        } else {
          coachChatForm.submit()
        }
      } else {
        console.error('CoachChatList - coach_chat_form not found in DOM')
      }
    }

    // Brief delay so Starting Chat / startingChatAt can propagate before navigation
    setTimeout(submitCoachChatForm, 75)
  }

  if (!open) return null

  if (!isConnected) {
    return <h2>{t('CoachChatList.finding_coaches')}</h2>
  }

  if (coaches === null) {
    return <h2>{t('CoachChatList.loading_coaches')}</h2>
  }

  return (
    <div className="coach-list flex h-full flex-col">
      <CoachListSections
        availableCoaches={coaches.length > 0 ? availableCoaches : []}
        busyCoaches={coaches.length > 0 ? busyCoaches : []}
        getJobTitle={(coach) => getCoachJobTitle(coach, { t, deloitteUser })}
        getBusyMessage={() => labels.currentlyBusy}
        isCoachExpanded={isCoachExpanded}
        onToggleExpanded={toggleCoachExpanded}
        onSelect={handleCoachAction}
        userCareerDevelopment={userCareerDevelopment}
        mediaAvailable={mediaAvailable}
        actionLabels={{
          video: labels.video,
          text: labels.text,
          audio: labels.audio,
        }}
        moreInfoLabel={labels.moreInfo}
        showLessLabel={labels.showLess}
        expandedLabels={{
          yearsExperience: labels.yearsExperience,
          supportedClients: labels.supportedClients,
          satisfactionRating: labels.satisfactionRating,
          aboutCoach: labels.aboutCoach,
        }}
        translateSkill={(skill) =>
          t(`coach_skills.${skill.toLowerCase().replace(/\s+/g, '-')}`)
        }
        availableHeading={getAvailableCoachesHeading(t, { deloitteUser })}
        busyHeading={t('CoachChatList.busy_coaches', {
          defaultValue: 'Currently Busy',
        })}
        emptyMessageHtml={inHours ? modalCopy?.busy : modalCopy?.after_hours}
      />
    </div>
  )
}

export default CoachChatList
